import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, NotFoundError } from "./ApiClient";
import { getTenantId } from "@utils/Auth";
import { ProviderFormData } from "@/formTypes/ProviderFormDataType";
import { buildClientOptionLabel } from "@utils/ClientLabel";

export type ProviderDataType = Partial<ApiSchema["Provider"]["type"] & ProviderFormData>;
class Api extends GenericModelApi<"Provider", ProviderDataType> {

    /**
     * Mismo criterio que en clientes: la etiqueta suma el nombre comercial cuando existe,
     * y se resuelve aqui para que todos los selects de proveedor la compartan.
     */
    async optionsList(filters: any = {},
        labelGenerator?: (item: ProviderDataType) => string,
        valueProp: keyof ProviderDataType = "id"
    ): Promise<Record<string, string>> {
        return super.optionsList(filters, labelGenerator ?? buildClientOptionLabel, valueProp);
    }

    async getProviderByIdentificacion(
        identificacion: string,
        selectionSet?: any
    ): Promise<ProviderDataType> {
        const tenantId = await getTenantId();

        const fetchFunction = ApiClient.models[this.modelName].listProviderByIdentificacionTenant;
        const { data, errors, nextToken: nt } = await fetchFunction({
            owner: tenantId,
            identificacion: { eq: identificacion },
        }, {
            limit: 1,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new ApiError("Error al obtener el provedor", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        if (pageItems.length > 0) {
            return pageItems[0]
        }

        throw new NotFoundError(`No existe ningun provedor del provedor con la identifiacion ${identificacion} `, "API_ERROR", errors);
    }
}

export const ProviderApi = new Api("Provider", "nombre")